module.exports = __webpack_public_path__ + "fonts/opensans-light-webfont.ee1efde2.eot";